/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## See build-api-client.ts for more details                  ##
 * ---------------------------------------------------------------
 */
import {
  Conversation,
  ConversationInput,
  ConversationIssue,
  ConversationMetadata,
  ConversationPart,
  ConversationsIssuesCluster,
  List,
} from "./data-contracts";

/**
 * No description
 * @tags conversations
 * @name ListConversationsIssuesClusters
 * @summary List conversations issues clusters
 * @request GET:/orgs/{organizationId}/conversations-clusters
 * @secure
 */

// @ts-ignore
export const listConversationsIssuesClusters: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
  };
  RequestQuery: {
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
    /**
     * An order for the items in the list
     * @default "desc"
     */
    order?: "asc" | "desc";
    /** @default "updatedAt" */
    orderBy?: "updatedAt" | "issues" | "conversations" | "impact";
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: ConversationsIssuesCluster[];
  };
  ResponseStatusCode: 200 | 404;
} = {
  route: "/orgs/{organizationId}/conversations-clusters",
  method: "get",
  streaming: false,
  tags: ["conversations"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags conversations
 * @name GetConversationsIssuesCluster
 * @summary Get a conversations issues cluster by its identifier
 * @request GET:/orgs/{organizationId}/conversations-clusters/{clusterId}
 * @secure
 */

// @ts-ignore
export const getConversationsIssuesCluster: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
    /** The unique id of the cluster */
    clusterId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: ConversationsIssuesCluster;
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/conversations-clusters/{clusterId}",
  method: "get",
  streaming: false,
  tags: ["conversations"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags conversations
 * @name UpdateConversationsIssuesCluster
 * @summary Update a conversations issues cluster
 * @request PATCH:/orgs/{organizationId}/conversations-clusters/{clusterId}
 * @secure
 */

// @ts-ignore
export const updateConversationsIssuesCluster: {
  route: string;
  method: "patch";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
    /** The unique id of the cluster */
    clusterId: string;
  };
  RequestQuery: {};
  RequestBody: {
    /** Whether the cluster is muted for change request creation */
    muted: boolean;
  };
  RequestHeaders: {};
  ResponseBody: ConversationsIssuesCluster;
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/conversations-clusters/{clusterId}",
  method: "patch",
  streaming: false,
  tags: ["conversations"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags conversations
 * @name ListConversations
 * @summary List conversations
 * @request GET:/orgs/{organizationId}/conversations
 * @secure
 */

// @ts-ignore
export const listConversations: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
  };
  RequestQuery: {
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
    /** Filter conversations by their source identifier */
    source?: string;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: Conversation[];
  };
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/conversations",
  method: "get",
  streaming: false,
  tags: ["conversations"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags conversations
 * @name IngestConversation
 * @summary Ingest conversations
 * @request POST:/orgs/{organizationId}/conversations
 * @secure
 */

// @ts-ignore
export const ingestConversation: {
  route: string;
  method: "post";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
  };
  RequestQuery: {};
  RequestBody: ConversationInput | ConversationInput[];
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204;
} = {
  route: "/orgs/{organizationId}/conversations",
  method: "post",
  streaming: false,
  tags: ["conversations"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags conversations
 * @name ListConversationsIssues
 * @summary List conversation issues
 * @request GET:/orgs/{organizationId}/conversations-issues
 * @secure
 */

// @ts-ignore
export const listConversationsIssues: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
  };
  RequestQuery: {
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
    /** Filter conversation issues by cluster identifier. */
    cluster?: string;
    /** Filter conversation issues by conversation identifier. */
    conversation?: string;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: {
      issue: ConversationIssue;
      conversation: Conversation;
    }[];
  };
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/conversations-issues",
  method: "get",
  streaming: false,
  tags: ["conversations"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags conversations
 * @name GetConversationIssueById
 * @summary Get a conversation issue by ID
 * @request GET:/orgs/{organizationId}/conversations-issues/{issueId}
 * @secure
 */

// @ts-ignore
export const getConversationIssueById: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
    /** Identifier of the conversation issue */
    issueId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: {
    issue: ConversationIssue;
    conversation: Conversation;
  };
  ResponseStatusCode: 200 | 404;
} = {
  route: "/orgs/{organizationId}/conversations-issues/{issueId}",
  method: "get",
  streaming: false,
  tags: ["conversations"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags conversations
 * @name GetConversationById
 * @summary Get a conversation by ID
 * @request GET:/orgs/{organizationId}/conversations/{conversationId}
 * @secure
 */

// @ts-ignore
export const getConversationById: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
    /** Identifier of the conversation */
    conversationId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: {
    conversation: Conversation;
    parts: ConversationPart[];
    metadata: ConversationMetadata;
  };
  ResponseStatusCode: 200 | 404;
} = {
  route: "/orgs/{organizationId}/conversations/{conversationId}",
  method: "get",
  streaming: false,
  tags: ["conversations"],
  criticalityLevel: "low",
  deprecated: false,
};
